import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upperCaseToCamelCase'
})
export class UpperCaseToCamelCasePipe implements PipeTransform {

    transform(value: string = ''): string {
        if (value.match(new RegExp(`[a-z]`))) {
            return value;
        } else {
            return value.toLowerCase()
                // uppercase the first character
                .replace(/^./, s => s.toUpperCase())
                // uppercase the first character after an underscore or space and remove an underscore or space
                .replace(/([\_\ ]\w)/g, s => s[1].toUpperCase());
        }
    }

}
